import { Injectable } from '@angular/core';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { BehaviorSubject } from 'rxjs';
import { NToggle } from '@df/ui/toggle/toggle.service';

@Injectable({
    providedIn: 'root'
})
export class StateReaderService {
    constructor(private toggleService: ToggleService) {}

    /**
     * Normalizes state into behavior subject
     * Useful for compoentns that take multiple types of inputs that need to be normalized
     */
    toState<T>(bare: T | BehaviorSubject<T> | NToggle.TGroupId | NToggle.TId): BehaviorSubject<T> {
        // array entry - toggle service thing
        if (Array.isArray(bare) || typeof bare === 'string' || typeof bare === 'number') {
            return this.toggleService.getState(bare) as any as BehaviorSubject<T>;
        }

        // object - plain subject
        if (bare && typeof bare === 'object') {
            return bare as BehaviorSubject<T>;
        }

        return new BehaviorSubject<T>(bare as T);
    }
}
